import React from 'react';

import { isEmpty } from 'lodash';

import InfoIcon from '@mui/icons-material/Info';

import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/styles';
import { PasswordPopper } from './PasswordPopper';
import { PasswordField } from './PasswordField';

export const CreatePasswordField = React.forwardRef(
  ({ errors = [], onChange, onError, onValidate, ...props }, forwardedRef) => {
    const [popperAnchorEl, setPopperAnchorEl] = React.useState(null);

    function handleInfoClick(event) {
      // toggle popper
      if (popperAnchorEl) {
        setPopperAnchorEl(null);
        return;
      }

      setPopperAnchorEl(event.target);
    }

    async function handleChange(e) {
      const { value } = e.target;
      onChange(value);

      if (typeof onChange === 'function') {
        try {
          if (typeof onValidate === 'function') {
            const remoteErrors = await onValidate(value);
            onError(remoteErrors);
          }
        } catch (error) {
          console.error(error);
          onError(error.response.data);
        }
      }
    }

    const isErrors = !isEmpty(errors);

    return (
      <>
        <Box>
          <PasswordField
            {...props}
            indent
            ref={forwardedRef}
            error={isErrors}
            onChange={handleChange}
          />

          <PasswordConstraintInfoAlert
            isAlert={isErrors}
            onInfoClick={handleInfoClick}
          />
        </Box>

        <PasswordPopper
          errors={errors}
          $anchorElem={popperAnchorEl}
          onClose={() => setPopperAnchorEl(null)}
        />
      </>
    );
  }
);

const InfoAlertIconButton = (props) => (
  <IconButton {...props} size="large">
    <InfoIcon />
  </IconButton>
);

const PasswordConstraintInfoAlert = styled(({ onInfoClick, ...props }) => (
  <Box {...props}>
    <InfoAlertIconButton
      onClick={onInfoClick}
      classes={{ color: 'inherit' }}
      size="small"
    />
    <span>View password requirements</span>
  </Box>
))((props) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: '2px',
  color: props.isAlert ? props.theme.palette.error.light : '',
  zIndex: 999,

  '& button': {
    color: 'inherit',
    marginRight: '4px',
  },
}));
